import { observable } from "mobx";

import { ApiConnector } from "../api/api-connector";
import { DataModel } from "./data-model";

export class APIDataModel<T extends object = any> extends DataModel<T> {
  @observable accessor loading = false;

  constructor(
    api: ApiConnector,
    private fetchData: () => Promise<T[]>,
  ) {
    super([], api.permissions, api.requireUserUUID());
  }

  async refresh() {
    this.loading = true;
    try {
      this.data = await this.fetchData();
      this.init();
    } finally {
      this.loading = false;
    }
  }
}
